export default {
    number: 3,
    options: [
      {
        number: 1,
        button: {
          text: 'Andar 5 passos',
          solution: {
            visible: false,
            board: 3,
          }
        },
      },
      {
        number: 2,
        button: {
          text: 'Andar -3 casas',
          solution: {
            visible: false,
            board: 4,
          }
        },
      },
      {
        number: 3,
        button: {
          text: 'Girar 120º',
          solution: {
            visible: false,
            board: 5,
          },
        },
      },
    ]
  }